import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('job_title', 'el puesto', 'los puestos')

const importJobTitles = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/job_title/import_job_titles`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los puestos correctamente.`,
		})
		showSuccessMessage('Se registraron los puestos correctamente')
		return res.body
	}
}

export default {...actions, importJobTitles}
